import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Post from '../components/Post';
import { useSiteMetadata } from '../hooks';
import { MarkdownRemark } from '../types';

type Props = {
  data: {
    markdownRemark: MarkdownRemark
  }
};

const PostTemplate: React.FC<Props>  = ({ data }) => {
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();
  const { frontmatter } = data.markdownRemark;
  const { title: postTitle, description: postDescription, socialImage, date, featured_image, slug} = frontmatter;
  const metaDescription = postDescription !== null ? postDescription : siteSubtitle;
  const imageUrl = featured_image ? `https://www.codevscolor.com${featured_image.childImageSharp.fluid.src}` : '';
  const postUrl = `https://www.codevscolor.com/${slug}`
  return (
    <Layout title={`${postTitle} - ${siteTitle}`} description={metaDescription} socialImage={socialImage} isBlogPost={true} datePublished={date} postUrl={postUrl} featuredImage={imageUrl}>
      <Post post={data.markdownRemark} />
    </Layout>
  );
};

export const query = graphql`
  query PostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
        tagSlugs
      }
      frontmatter {
        date
        updated
        description
        tags
        title
        slug
        socialImage
        featured_image {
          childImageSharp {
            fluid(maxWidth: 630, quality: 10) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default PostTemplate;
